import React from 'react';
import Tooltip from '../Tooltip';
export default function factoryTooltip(TooltipComp, variant) {
    return (props) => {
        return React.createElement(Tooltip, Object.assign({ _TooltipComp: TooltipComp, _variant: variant }, props));
    };
}
//# sourceMappingURL=factoryTooltip.js.map